import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Rx';
import { EventManager, ParseLinks, PaginationUtil, JhiLanguageService, AlertService } from 'ng-jhipster';

import { EventReservation } from './event-reservation.model';
import { EventReservationService } from './event-reservation.service';
import { ITEMS_PER_PAGE, Principal } from '../../shared';
import { PaginationConfig } from '../../blocks/config/uib-pagination.config';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { SchoolCalendar, SchoolCalendarService} from '../../entities/school-calendar';

import { StudentService } from '../../entities/student/student.service';
import { Student } from '../student/student.model';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';

@Component({
    selector: 'jhi-event-reservation',
    templateUrl: './event-reservation.component.html'
})
export class EventReservationComponent implements OnInit, OnDestroy {

    currentAccount: any;
    eventReservations: EventReservation[];
    error: any;
    success: any;
    eventSubscriber: Subscription;
    currentSearch: string;
    routeData: any;
    links: any;
    totalItems: any;
    queryCount: any;
    itemsPerPage: any;
    page: any;
    predicate: any;
    previousPage: any;
    reverse: any;

    // for the search functions
    eventReservationsCalendarFrom: NgbDateStruct;
    eventReservationsSearchFrom: Date;
    eventReservationsCalendarTo: NgbDateStruct;
    eventReservationsSearchTo: Date;
    eventReservationsCalendarToMinDate: NgbDateStruct;
    eventReservationsCalendarToMaxDate: NgbDateStruct;
    currentStudent: Student;
    currentUserIsStudent: boolean;
    isReservationsSearching: boolean;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private eventReservationService: EventReservationService,
        private schoolCalendarService: SchoolCalendarService,
        private studentService: StudentService,
        private parseLinks: ParseLinks,
        private alertService: AlertService,
        private principal: Principal,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private eventManager: EventManager,
        private paginationUtil: PaginationUtil,
        private paginationConfig: PaginationConfig
    ) {
        this.itemsPerPage = ITEMS_PER_PAGE;
        this.routeData = this.activatedRoute.data.subscribe(data => {
            this.page = data['pagingParams'].page;
            this.previousPage = data['pagingParams'].page;
            this.reverse = data['pagingParams'].ascending;
            this.predicate = data['pagingParams'].predicate;
        });
        this.currentSearch = activatedRoute.snapshot.params['search'] ? activatedRoute.snapshot.params['search'] : '';

        if (this.currentSearch) {
            this.eventReservationsCalendarFrom = {
                year: parseInt(activatedRoute.snapshot.params['yearFrom'], 10),
                month:  parseInt(activatedRoute.snapshot.params['monthFrom'], 10),
                day:  parseInt(activatedRoute.snapshot.params['dayFrom'], 10)
            };

            this.eventReservationsCalendarTo = {
                year: parseInt(activatedRoute.snapshot.params['yearTo'], 10),
                month:  parseInt(activatedRoute.snapshot.params['monthTo'], 10),
                day:  parseInt(activatedRoute.snapshot.params['dayTo'], 10)
            };

        }
        this.jhiLanguageService.setLocations(['eventReservation', 'event',
                                              'payment', 'paymentType', 'paymentItem']);
    }

    ngOnInit() {
        this.principal.identity().then((account) => {
            this.currentAccount = account;
            this.principal
            .hasOnlyAuthority('ROLE_USER')
            .then((res) => {
                if (res) {
                    // The current user is a student
                    this.currentUserIsStudent = true;
                }
            });

            this.studentService.getCurrent().subscribe((student: any) => {
                this.currentStudent = student;
                this.initEventReservationsCalendar();
                this.search();
            });

            this.registerChangeInReservations();
        });
    }

    loadEventReservations() {
        this.currentSearch = 'student.id:' + this.currentStudent.id + ' AND '
                             + this.getDateRangeQuery(this.eventReservationsCalendarFrom,
                                this.eventReservationsCalendarTo);

        let searchParams = this.getDateSearchParams(this.eventReservationsCalendarFrom,
                                                    this.eventReservationsCalendarTo);

        this.eventReservationService.search({
            page: this.page - 1,
            query: this.currentSearch,
            size: this.itemsPerPage,
            sort: this.sort(),
            ...searchParams
        }).subscribe(
            (res: HttpResponse<EventReservation[]>) => this.onSuccess(res.body, res.headers),
            (res: HttpErrorResponse) => this.onError(res)
            );
    }

    private getDateRangeQuery(fromDate: NgbDateStruct, toDate: NgbDateStruct) {
        let fromDateTerm: String;
        let toDateTerm: String;

        if (fromDate) {
            let fromMonth: number = fromDate.month;
            let fromDay: number = fromDate.day;

            fromDateTerm = fromDate.year + '-'
                + (fromMonth < 10 ? '0' + fromMonth : fromMonth)
                + '-' + (fromDay < 10 ? '0' + fromDay : fromDay);
        } else {
            fromDateTerm = '*';
        }

        if (toDate) {
            let realToDate = new Date(toDate.year, toDate.month - 1, toDate.day);
            realToDate.setDate(realToDate.getDate());
            let toDay = realToDate.getDate();
            let toMonth = realToDate.getMonth() + 1 ;
            toDateTerm = realToDate.getFullYear() + '-'
                + (toMonth < 10 ? '0' + toMonth : toMonth )
                + '-'  + (toDay < 10 ? '0' + toDay : toDay);

        } else {
            toDateTerm = '*';
        }

        return 'event.begining:[ ' + fromDateTerm + ' TO ' + toDateTerm + ']';
    }

    getDateSearchParams(searchDateFrom: NgbDateStruct, searchDateTo: NgbDateStruct) {
        let result: any = {};

        if (searchDateFrom) {
            result.yearFrom = searchDateFrom.year;
            result.monthFrom = searchDateFrom.month;
            result.dayFrom = searchDateFrom.day;
        }

        if (searchDateTo) {
            result.yearTo = searchDateTo.year;
            result.monthTo = searchDateTo.month;
            result.dayTo = searchDateTo.day;
        }

        return result;
    }

    loadPage(page: number) {
        if (page !== this.previousPage) {
            this.previousPage = page;
            this.transition();
        }
    }

    transition() {
        this.router.navigate(['/event-reservation'], {
            queryParams:
            {
                page: this.page,
                size: this.itemsPerPage,
                search: this.currentSearch,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc'),
                ...this.getDateSearchParams(this.eventReservationsCalendarFrom,
                    this.eventReservationsCalendarTo)
            }
        });
        this.loadEventReservations();
    }

    clear() {
        this.page = 0;
        this.currentSearch = '';
        this.isReservationsSearching = false;
        this.initEventReservationsCalendar();
        this.loadEventReservations();
    }

    search() {
        this.isReservationsSearching = true;
        this.page = 0;
        let dateSearchParams = this.getDateSearchParams(this.eventReservationsCalendarFrom,
            this.eventReservationsCalendarTo);
        this.loadEventReservations();
        this.router.navigate(['/event-reservation', {
            search: this.currentSearch,
            page: this.page,
            sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc'),
            ...dateSearchParams
        }]);
    }

    /**
     * Returns true if all validations to activate the search button pass.
     */
    isSearchActive() {
            return this.isDateRangeValid(this.eventReservationsCalendarFrom,
                this.eventReservationsCalendarTo);
    }

     /**
     * Returns true whether the specified date range is valid; false otherwise.
     * */
    isDateRangeValid(fromDateInput, toDateInput) {
        if (fromDateInput && toDateInput) {
            let fromDate = new Date(fromDateInput.year, fromDateInput.month - 1, fromDateInput.day);
            let toDate = new Date(toDateInput.year, toDateInput.month - 1, toDateInput.day);

            return (fromDate <= toDate);
        }

        return true;
    }

    private initEventReservationsCalendar() {
        let fromDate: Date;
        let toDate: Date;

        fromDate = new Date();
        const oneMonthLater = new Date(fromDate);
        oneMonthLater.setMonth(fromDate.getMonth() + 1);

        this.eventReservationsCalendarFrom = this.fromDate(fromDate);
        this.eventReservationsCalendarTo = this.fromDate(oneMonthLater);

        this.eventReservationsSearchFrom = new Date(fromDate);
        this.eventReservationsSearchTo = new Date(toDate);
    }

    private fromDate(date: Date): NgbDateStruct {
        if (date) {
            return {
                day: date.getDate(),
                month: date.getMonth() + 1,
                year: date.getFullYear()
            };
        }

        return {
            day: 18,
            month: 3,
            year: 1951
        };
    }

    private toDate(jsonDate: Object): Date {
        if (jsonDate !== null) {
            let year = jsonDate['year'];
            let month = jsonDate['month'];
            let day = jsonDate['day'];

            if (year != null && month != null && day != null) {
                let d = new Date();
                d.setDate(day);
                d.setFullYear(year);
                d.setMonth(month - 1);

                return d;
            }
        }

        return null;
    }


    ngOnDestroy() {
        this.eventManager.destroy(this.eventSubscriber);
    }

    trackId(index: number, item: EventReservation) {
        return item.id;
    }

    registerChangeInReservations() {
        this.eventSubscriber = this.eventManager.subscribe('eventParticipantsListModification',
            (response) => this.loadEventReservations());
    }

    sort() {
        let result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
        return result;
    }

    private eventReservationCalendarfromDateChanged(fromDate: NgbDateStruct) {
        if (!fromDate) {
            return;
        }

        // We set the min date of the toCalendar the same date fromDate
        let minDate: Date = new Date(fromDate.year, fromDate.month - 1, fromDate.day);
        this.eventReservationsCalendarToMinDate = {
            year: minDate.getFullYear(),
            month: minDate.getMonth() + 1,
            day: minDate.getDate()
        };

        // We set the max date of the toCalendar to one year from the fromDate
        let maxDate: Date = new Date(fromDate.year, fromDate.month - 1 + 12 , fromDate.day);
        this.eventReservationsCalendarToMaxDate = {
            year: maxDate.getFullYear(),
            month: maxDate.getMonth() + 1,
            day: maxDate.getDate()
        };
    }

    private onSuccess(data, headers) {
        this.links = this.parseLinks.parse(headers.get('link'));
        this.totalItems = headers.get('X-Total-Count');
        this.queryCount = this.totalItems;
        // this.page = pagingParams.page;
        this.eventReservations = data;
    }

    private onError(error) {
        this.alertService.error(error.message, null, null);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/event-reservation/event-reservation.component.ts